/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React from 'react';
import {
  CheckboxContainer,
  CircleIcon,
  CircleIconWrapper,
  CheckboxLabel,
  checkboxSize,
  HiddenCheckbox,
  CheckboxText,
  Icon,
  StyledCheckbox
} from './checkbox-v2.styles';
import CheckCircle from '../check-circle';

const getCheckboxUI = props => {
  const { value, checkCircle, round, disabled } = props || {};

  return checkCircle && !!value ? (
    <CheckCircle $green $size={checkboxSize} />
  ) : (
    <StyledCheckbox
      checked={value}
      round={round || checkCircle}
      disabled={disabled}
    >
      {round ? (
        <CircleIconWrapper viewBox="-7 -7 24 24">
          <CircleIcon />
        </CircleIconWrapper>
      ) : (
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      )}
    </StyledCheckbox>
  );
};

const CheckboxV2 = props => {
  const {
    text,
    validate,
    disabled,
    value,
    onChange,
    textStyles,
    ...rest
  } = props;
  const { id } = rest;

  return (
    <>
      <CheckboxLabel
        htmlFor={id}
        data-cv-test={`${rest['data-cv-test']}Label`}
        onChange={e => onChange(e, validate)}
      >
        <CheckboxContainer data-cv-test={`${rest['data-cv-test']}Container`}>
          <HiddenCheckbox checked={value} onChange={() => {}} />
          {getCheckboxUI(props)}
        </CheckboxContainer>

        {text && (
          <CheckboxText css={textStyles} disabled={disabled}>
            {text}
          </CheckboxText>
        )}
      </CheckboxLabel>
    </>
  );
};

CheckboxV2.propTypes = {
  onChange: PropTypes.func.isRequired,
  textStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  checkCircle: PropTypes.bool,
  onTouched: PropTypes.func,
  disabled: PropTypes.bool,
  round: PropTypes.bool,
  uuid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validate: PropTypes.func
};

CheckboxV2.defaultProps = {
  textStyles: [],
  text: null,
  checkCircle: false,
  onTouched: null,
  disabled: false,
  round: false,
  validate: () => {}
};

export default CheckboxV2;
